import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridCriteriaModel } from '@core/services/lookup/grid-criteria.model';
import { AppConfig } from 'app/app.config';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GridService {
  public updated: BehaviorSubject<string>;
  public updated$: Observable<string>;
  constructor(private httpClient: HttpClient) {
    // THIS ORDER REQUIRED
    this.updated = new BehaviorSubject<string>('-1');
    this.updated$ = this.updated.asObservable();
  }

  public refreshGridData(gridCriteria: GridCriteriaModel): Observable<string> {
    return this.httpClient.post<string>(`${AppConfig.settings.settings.apiEndpoint}api/Grid/Refresh`, gridCriteria)
      .pipe(map(value => {
        return value;
      }));
  }
}
